import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";

import { TTP_API_URL } from "Config";
import { ICONS, SvgIcon } from "../Common/Icons";
import { getUserNameForAvatar } from "Utils";
import Comments from "./Comments";
import styles from "./PreparePresentation.local.scss";
import AudioReactRecorder, { RecordState } from "audio-react-recorder";
import "audio-react-recorder/dist/index.css";
import { inIframe } from "Utils";
class SlidesComments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stoped: false,
      audioData: null,
      recording: false,
      recordState: null,
      displayCommentAction: null
    };
  }

  setSelectedCommentAction = id => {
    let { displayCommentAction } = this.state;
    if (displayCommentAction === id) {
      this.setState({ displayCommentAction: null });
    } else {
      this.setState({ displayCommentAction: id });
    }
  };

  deleteComment = id => {
    this.setState({ displayCommentAction: null });
    this.props.deleteComment(id);
  };

  updateComment = (id, content) => {
    this.setState({ displayCommentAction: null });
    this.props.updateComment(id, content);
  };

  saveComment = () => {
    const { comment } = this.props;
    if (comment.content.length === 0) {
      return;
    } else {
      this.props.saveComment();
    }
  };

  handleClearComment = () => {
    this.props.clearComment();
  };

  displayRecordingAudio = () => {
    this.setState({
      recording: true
    });
  };

  saveRecordingAudio = () => {
    this.props.saveVoiceComment(this.state.audioData);
    this.exitRecordingAudio();
  };

  deleteRecordingAudio = () => {
    this.setState({
      stoped: false,
      audioData: null,
      recordState: null
    });
  };

  exitRecordingAudio = () => {
    this.setState({
      stoped: false,
      recording: false,
      audioData: null,
      recordState: null
    });
  };

  start = () => {
    this.setState({
      recordState: RecordState.START
    });
  };

  pause = () => {
    this.setState({
      recordState: RecordState.PAUSE
    });
  };

  stop = () => {
    this.setState({
      stoped: true,
      recordState: RecordState.STOP
    });
  };

  onStop = data => {
    this.setState({
      audioData: data
    });
  };

  render() {
    const { comments, comment, saving, user, slideId } = this.props;
    let { displayCommentAction, recordState, recording } = this.state;
    let avatar = [];
    if (user.avatarUrl !== undefined) {
      avatar.push(
        <img src={user.avatarUrl} alt={""} className={styles.input_icon} />
      );
    } else if (user.avatar) {
      avatar.push(
        <img
          src={`${TTP_API_URL}/${user.avatar}`}
          alt={""}
          className={styles.input_icon}
        />
      );
    } else {
      avatar.push(
        <span className={styles.input_icon}>
          {getUserNameForAvatar(user.firstName, user.lastName)}
        </span>
      );
    }
    let commentaires = [];
    comments &&
      // eslint-disable-next-line array-callback-return
      comments.map((item, i) => {
        if (item.slideCode === slideId) {
          commentaires.push(item);
        }
      });
    return (
      <Fragment>
        <div className={styles.add_comment_container}>
          <div className={styles.div_input}>
            {avatar[0]}
            {!recording ? (
              <textarea
                id={"new-comment"}
                type={"text"}
                placeholder={_("addComment")}
                onChange={e => this.props.handleInputChange(e)}
              />
            ) : (
              <div
                className={
                  this.state.stoped ? styles.hidden_canvas : styles.hidden_audio
                }
              >
                <AudioReactRecorder
                  canvasWidth={385}
                  canvasHeight={40}
                  state={recordState}
                  onStop={this.onStop}
                  backgroundColor="rgb(255,255,255)"
                />
                <audio
                  id="audio"
                  controls
                  src={this.state.audioData ? this.state.audioData.url : null}
                />
                {this.state.stoped ? (
                  <div className={inIframe() === true && styles.inIframe}>
                    <Fragment>
                      <button
                        id="delete"
                        className={classnames(
                          styles.record_button,
                          styles.delete_button
                        )}
                        style={{ right: inIframe() && "65px" }}
                        onClick={this.deleteRecordingAudio}
                      >
                        <SvgIcon icon={ICONS.DELETE_ICON} />
                      </button>
                      <button
                        id="send"
                        className={classnames(
                          styles.record_button,
                          styles.send_button
                        )}
                        style={{ right: inIframe() && "20px" }}
                        onClick={this.saveRecordingAudio}
                      >
                        <SvgIcon icon={ICONS.SEND} />
                      </button>
                      <button
                        id="exit"
                        className={classnames(
                          styles.record_button,
                          styles.exit_button
                        )}
                        style={{ right: inIframe() && "-24px" }}
                        onClick={this.exitRecordingAudio}
                      >
                        <SvgIcon icon={ICONS.EXIT_ICON} />
                      </button>
                    </Fragment>
                  </div>
                ) : (
                  <div className={inIframe() === true && styles.inIframe}>
                    <Fragment>
                      <button
                        id="record"
                        className={classnames(
                          styles.record_button,
                          styles.mic_button
                        )}
                        onClick={this.start}
                        style={{ right: inIframe() && "65px" }}
                      >
                        <SvgIcon icon={ICONS.MIC_ICONE} />
                      </button>
                      <button
                        id="pause"
                        className={classnames(
                          styles.record_button,
                          styles.pause_button
                        )}
                        style={{ right: inIframe() && "20px" }}
                        onClick={this.pause}
                      >
                        <SvgIcon icon={ICONS.PAUSE_ICONE} />
                      </button>
                      <button
                        id="stop"
                        className={classnames(
                          styles.record_button,
                          styles.stop_button
                        )}
                        style={{ right: inIframe() && "-24px" }}
                        onClick={this.stop}
                      >
                        <SvgIcon icon={ICONS.STOP_ICONE} />
                      </button>
                    </Fragment>
                  </div>
                )}
              </div>
            )}
          </div>
          {!recording && (
            <div>
              <span
                style={{ background: "#18A0FB", color: "white" }}
                className={classnames(
                  styles.transparent_btn,
                  styles.span_btn,
                  saving ? styles.saving : "",
                  comment.content.length === 0 ? styles.disabled : ""
                )}
                onClick={() => this.saveComment()}
              >
                <img
                  src={"/img/icons/tail-spin.svg"}
                  alt={""}
                  className={saving ? styles.loading : ""}
                />
                {_("post")}
              </span>
              <span
                className={classnames(styles.transparent_btn, styles.span_btn)}
                onClick={() => this.handleClearComment()}
              >
                <img src={"/img/icons/tail-spin.svg"} alt={""} />
                {_("cancel")}
              </span>
              <span
                className={classnames(styles.transparent_btn, styles.large_btn)}
                onClick={() => this.displayRecordingAudio()}
              >
                {_("recordVocal")}
              </span>
            </div>
          )}
        </div>
        <div className={styles.comments_container}>
          {commentaires.map((comment, j) => {
            return (
              <Comments
                comment={comment}
                selectedComment={displayCommentAction}
                displayCommentAction={this.setSelectedCommentAction}
                deleteComment={this.deleteComment}
                updateComment={this.updateComment}
                handleInputChange={this.props.handleInputChange}
                keyPressed={this.props.keyPressed}
              />
            );
          })}
        </div>
      </Fragment>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  comments: state.preparePresentation.items.comments,
  comment: state.preparePresentation.comment,
  saving: state.preparePresentation.saving,
  user: state.auth.user
});

export default connect(mapStateToProps)(SlidesComments);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/SlidesComments.js